import React, { ReactNode } from 'react';
import Header from './Header';
import BottomNav from './BottomNav';

interface LayoutProps {
  children: ReactNode;
  showHeader?: boolean;
  showBottomNav?: boolean;
  title?: string;
  showBack?: boolean;
  onBack?: () => void;
  headerRight?: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  showHeader = true,
  showBottomNav = true,
  title,
  showBack,
  onBack,
  headerRight
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {showHeader && (
        <Header 
          title={title}
          showBack={showBack}
          onBack={onBack}
          rightContent={headerRight}
        />
      )}
      
      <main className={`flex-1 ${showHeader ? 'pt-14' : ''} ${showBottomNav ? 'pb-16' : ''}`}>
        {children}
      </main>
      
      {showBottomNav && <BottomNav />}
    </div>
  );
};

export default Layout;